import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Mail } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useSeo } from "../../lib/useSeo";
import { Button } from "../../components/ui/button";

const MakelaarPending = () => {
  useSeo({ title: "Verificatie in behandeling · WoningAlert" });
  const { user, logout } = useAuth();
  const status = (user?.verification_status || "pending").toLowerCase();

  const title = status === "rejected" ? "Je aanvraag is afgewezen" : "Je account wacht op goedkeuring";
  const body =
    status === "rejected"
      ? "Helaas is je makelaar-account afgewezen. Neem contact met ons op als je denkt dat dit een vergissing is."
      : "We controleren je gegevens handmatig (KvK en lidmaatschap). Dit duurt doorgaans 1 werkdag. Zodra je bent goedgekeurd kun je woningen plaatsen.";

  return (
    <div className="mx-auto max-w-xl px-4 py-20 text-center sm:px-6">
      <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-brandblue-light text-brandblue">
        <ShieldCheck size={30} />
      </div>
      <h1 className="mt-6 font-display text-3xl font-extrabold text-navy" data-testid="pending-title">
        {title}
      </h1>
      <p className="mt-3 text-slate-500">{body}</p>

      <div className="mt-8 rounded-2xl border border-border bg-white p-5 text-left shadow-sm">
        <div className="text-xs font-semibold uppercase tracking-wide text-slate-400">Jouw aanvraag</div>
        <dl className="mt-3 space-y-2 text-sm">
          <div className="flex justify-between gap-4"><dt className="text-slate-500">Naam</dt><dd className="font-semibold text-navy">{user?.name || "—"}</dd></div>
          <div className="flex justify-between gap-4"><dt className="text-slate-500">E-mail</dt><dd className="font-semibold text-navy">{user?.email || "—"}</dd></div>
          <div className="flex justify-between gap-4"><dt className="text-slate-500">Kantoor</dt><dd className="font-semibold text-navy">{user?.agency_name || "—"}</dd></div>
          <div className="flex justify-between gap-4"><dt className="text-slate-500">KvK</dt><dd className="font-semibold text-navy">{user?.kvk_number || "—"}</dd></div>
          <div className="flex justify-between gap-4"><dt className="text-slate-500">NVM/VBO</dt><dd className="font-semibold text-navy">{user?.nvm_vbo_number || "—"}</dd></div>
        </dl>
      </div>

      <div className="mt-8 flex flex-wrap justify-center gap-3">
        <Button asChild variant="outline" className="rounded-xl">
          <a href="mailto:support@woningalert.nl"><Mail size={16} className="mr-2" /> Contact opnemen</a>
        </Button>
        <Button variant="outline" onClick={logout} className="rounded-xl" data-testid="logout-btn">Uitloggen</Button>
        <Button asChild className="rounded-xl bg-brandblue hover:bg-brandblue/90">
          <Link to="/">Terug naar home</Link>
        </Button>
      </div>
    </div>
  );
};

export default MakelaarPending;
